@let navbarWidth = store.widthSg();
@let slideoutExpanded = store.slideoutExpandedSg();

<!-- NOTE: Full height is not working if we pass position input like: position="l" -->
<atn-ds-slideout-overlay
  name="Assistants"
  [position]="'l'"
  [offsetX]="navbarWidth"
>
  @let selectedAssistantDisplay = assistants.selectedAssistantDisplaySg();
  @let conversationId = assistants.currentConversationIdSg();
  @let selectedConversationalGroup = assistants.selectedConversationalGroupSg();

  <ng-container actions>
    @if (
      selectedAssistantDisplay &&
      assistants.selectedAgentCanConfigureFunctionalitySg()
    ) {
      <i
        class="atn-icon atn-settings atn-blue"
        title="Configure agent context"
        (click)="openConfig(selectedAssistantDisplay.id, conversationId)"
      ></i>
    }
    <i
      class="atn-icon atn-blue"
      [class.atn-expand]="!slideoutExpanded"
      [class.atn-contract]="slideoutExpanded"
      (click)="store.toggleExpandCollapseSlideout()"
    ></i>
    <i
      class="atn-icon atn-close atn-red"
      (click)="
        selectedConversationalGroup?.conversation?.plugins?.currentEntityPlugin?.storage?.actions?.putInIdLookup?.request
          ?.from('AssistantSlideout.CloseButton.Clicked')
          ?.dispatch({ value: undefined });
        close.emit()
      "
    ></i>
  </ng-container>
  <div
    class="atn-assistant-slideout"
    [class.atn-assistant-slideout--expanded]="slideoutExpanded"
    [style.--atn-assistant-slideout-navbar-width]="navbarWidth + 'px'"
  >
    <atn-assistant [fullScreen]="slideoutExpanded" />
  </div>
</atn-ds-slideout-overlay>

@if (isConfigOpenSg()) {
  <atn-assistant-configuration />
}
